import { useTranslation, Trans } from "react-i18next";
import { useRef } from 'react'
import h1 from '../../img/SpecialOffers/h1.svg'
import h2 from '../../img/SpecialOffers/h2.svg'
import h3 from '../../img/SpecialOffers/h3.svg'
import h4 from '../../img/SpecialOffers/h4.svg'

import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, Autoplay } from "swiper/modules";

import b1 from "../../img/Home/back.svg";
import b2 from "../../img/Home/next.svg";

import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

function HowToEarnTickets() {

  const { t } = useTranslation();

  const prevRef = useRef(null);
  const nextRef = useRef(null);
  const paginationRef = useRef(null);

  return (
    <div className="relative pt-[80px] xl:pt-[160px] overflow-hidden">
      <div className="max-w-[1220px] mx-[20px] xl:mx-auto">
        <div className="flex flex-col xl:flex-row items-center gap-[20px] justify-between">
            <p className="zen-dots leading-[1.2] text-[24px] xl:text-[36px] text-[#FFF] xl:max-w-[595px]">
                <Trans>{t("offers.6")}</Trans>
            </p>
            <p className="xl:max-w-[497px] text-[#FFFFFFB2] text-[14px] ibm-plex">
                {t("offers.7")}
            </p>
        </div>
        <div className="xl:flex justify-between gap-[20px] mt-[40px] xl:mt-[60px] hidden">
            <div className="w-[600px] h-[254px] bg-[#2A2A3D] border-[#00000033] border px-[20px] xl:px-[40px] py-[20px]">
                <div className="bg-[#2045FE] w-[69px] h-[69px] flex items-center justify-center">
                    <img src={h1} alt="" />
                </div>
                <div className="mt-[24px] flex items-center gap-[18px]">
                    <div className="w-[2px] h-[18px] bg-white"></div>
                    <p className="zen-dots text-[16px] xl:text-[20px] text-white">{t('offers.8')}</p>
                </div>
                <p className="xl:max-w-[403px] mt-[12px] ibm-plex text-[12px] xl:text-[14px] text-[#FFFFFFB2]">{t('offers.9')}</p>
            </div>
            <div className="w-[600px] h-[254px] bg-[#2A2A3D] border-[#00000033] border mt-[-1px] px-[20px] xl:px-[40px] py-[20px]">
                <div className="bg-[#2045FE] w-[69px] h-[69px] flex items-center justify-center">
                    <img src={h3} alt="" />
                </div>
                <div className="mt-[24px] flex items-center gap-[18px]">
                    <div className="w-[2px] h-[18px] bg-white"></div>
                    <p className="zen-dots text-[16px] xl:text-[20px] text-white">{t('offers.12')}</p>
                </div>
                <p className="xl:max-w-[403px] mt-[12px] ibm-plex text-[12px] xl:text-[14px] text-[#FFFFFFB2]">{t('offers.13')}</p>
            </div>
            <div className="w-[600px] h-[254px] bg-[#2A2A3D] border-[#00000033] border px-[20px] xl:px-[40px] py-[20px]">
                <div className="bg-[#2045FE] w-[69px] h-[69px] flex items-center justify-center">
                    <img src={h2} alt="" />
                </div>
                <div className="mt-[24px] flex items-center gap-[18px]">
                    <div className="w-[2px] h-[18px] bg-white"></div>
                    <p className="zen-dots text-[16px] xl:text-[20px] text-white">{t('offers.10')}</p>
                </div>
                <p className="xl:max-w-[403px] mt-[12px] ibm-plex text-[12px] xl:text-[14px] text-[#FFFFFFB2]">{t('offers.11')}</p>
            </div>
        </div>
        <div className="xl:hidden mt-[40px]"> 
        <Swiper
            modules={[Navigation, Pagination, Autoplay]}
            loop={true}
            autoplay={true}
            className="w-full h-full"
            navigation={{
                prevEl: prevRef.current,
                nextEl: nextRef.current,
            }}
            pagination={{
                el: paginationRef.current,
                clickable: true,
            }}
            onBeforeInit={(swiper) => {
                swiper.params.navigation.prevEl = prevRef.current;
                swiper.params.navigation.nextEl = nextRef.current;
                swiper.params.pagination.el = paginationRef.current;
            }}
            breakpoints={{
                0: {
                    slidesPerView: 1,
                },
                768: {
                    slidesPerView: 2,
                },
                1280: {
                    slidesPerView: 1,
                },
            }}
        >
            <SwiperSlide>
            <div className="px-[20px] pt-[20px] md:border-l border-[#00000033] bg-[#2A2A3D] h-[200px]">
                <div className="bg-[#2045FE] w-[42px] h-[42px] flex items-center justify-center">
                    <img src={h1} alt="" className="w-[22px] h-[22px]"/>
                </div>
                <div className="mt-[24px] flex items-center gap-[18px]">
                    <div className="w-[2px] h-[18px] bg-[#fff]"></div>
                    <p className="zen-dots text-[16px] xl:text-[20px] text-[#fff]">{t('offers.8')}</p>
                </div>
                <p className="xl:max-w-[403px] mt-[12px] ibm-plex text-[12px] xl:text-[14px] text-[#FFFFFFB2]">{t('offers.9')}</p>
            </div>  
            </SwiperSlide>
            <SwiperSlide>
            <div className="px-[20px] pt-[20px] md:border-l h-[200px] border-[#00000033] bg-[#2A2A3D]">
                <div className="bg-[#2045FE] w-[42px] h-[42px] flex items-center justify-center">
                    <img src={h2} alt="" className="w-[22px] h-[22px]"/>
                </div>
                <div className="mt-[24px] flex items-center gap-[18px]">
                    <div className="w-[2px] h-[18px] bg-[#fff]"></div>
                    <p className="zen-dots text-[16px] xl:text-[20px] text-[#fff]">{t('offers.10')}</p>
                </div>
                <p className="xl:max-w-[403px] mt-[12px] ibm-plex text-[12px] xl:text-[14px] text-[#FFFFFFB2]">{t('offers.11')}</p>
            </div>  
            </SwiperSlide>
            <SwiperSlide>
            <div className="px-[20px] pt-[20px] md:border-l h-[200px] border-[#00000033] bg-[#2A2A3D]">
                <div className="bg-[#2045FE] w-[42px] h-[42px] flex items-center justify-center">
                    <img src={h3} alt="" className="w-[22px] h-[22px]"/>
                </div>
                <div className="mt-[24px] flex items-center gap-[18px]">
                    <div className="w-[2px] h-[18px] bg-[#fff]"></div>
                    <p className="zen-dots text-[16px] xl:text-[20px] text-[#fff]">{t('offers.12')}</p>
                </div>
                <p className="xl:max-w-[403px] mt-[12px] ibm-plex text-[12px] xl:text-[14px] text-[#FFFFFFB2]">{t('offers.13')}</p>
            </div>  
            </SwiperSlide>
        </Swiper>
        </div>
        <div className="flex xl:hidden items-center justify-between mt-auto border-t bg-[#2A2A3D] border-[#00000033] h-[48px]">
            <div ref={paginationRef} className="pl-[20px] md:pl-[50px] pb-[5px] !w-[200px]"></div>
            <div className="flex">
                <button ref={prevRef} className="w-[124px] border-l hover:border hover:border-black transition-all h-[48px] border-[#00000033] flex items-center justify-center cursor-my"><img src={b1} alt="" /></button>
                <button ref={nextRef} className="w-[124px] border-l hover:border hover:border-black transition-all h-[48px] border-[#00000033] flex items-center justify-center cursor-my"><img src={b2} alt="" /></button>
            </div>
        </div>
      </div>
    </div>
  );
}

export default HowToEarnTickets;
